export default `
	imageTextSplit {
		...on ImageTextSplitItem {
			image {
				size
				width
				height
				filename
			}
			headline
			subline
			paragraph {
				content
			}
		}
	}
`;
